/**
 * .select2Buttons - Convert standard html select into button like elements
 *
 * Version: 1.0.1
 * Updated: 2011-04-14
 *
 *  Provides an alternative look and feel for HTML select buttons, inspired by threadless.com
 *
 * Author: Sam Cavenagh (cavenaghweb@hotmail.com)
 * Doco and Source: https://github.com/o-sam-o/jquery.select2Buttons
 *
 * Licensed under the MIT
 **/
jQuery.fn.select2Buttons = function (options) {
  return this.each(function () {
    var $ = jQuery;
    var select = $(this);
    var multiselect = select.attr('multiple');
    select.hide();

    var buttonsHtml = $('<div class="select2Buttons"></div>');
    var selectIndex = 0;
    var addOptGroup = function (optGroup) {
      if (optGroup.attr('label')) {
        buttonsHtml.append('<strong>' + optGroup.attr('label') + '</strong>');
      }
      var ulHtml = $('<ul class="select-buttons">');
      optGroup.children('option').each(function () {
        var liHtml = $('<li></li>');
        if ($(this).attr('disabled') || select.attr('disabled')) {
          liHtml.addClass('disabled');
          var disabled = $(this).text();
          liHtml.append("<span>" + disabled + " <span  id='notifyme' class='qut_'>Notify me</span></span>");

          //liHtml.append('<span>' + $(this).html() + '</span>');
        } else {
          var ab = "";
          ab = $(this).text().split('_');
          // console.log(ab);
          if ($.trim(ab[1]) != "1 left") {
            liHtml.append('<a href="#" data-select-index="' + selectIndex + '">' + ab[0] + '</a>');
          } else {
            liHtml.append('<a href="#" data-select-index="' + selectIndex + '">' + ab[0] + "<span class='qut_'>" + ab[1] + "</span>" + '</a>');
          }

        }

        // Mark current selection as "picked"
        if ((!options || !options.noDefault) && $(this).attr('selected')) {
          var current_pick = $(this).text().split('_');
          $('.picked_value').html("Choose Your Size : <span class='crrnt_vl'> " + current_pick[0] + "</span><span class='qut_ crrnt_vl'>" + current_pick[1] + "</span>");
          liHtml.children('a, span').addClass('picked');

          $(document).ready(function () {
            // Disable ATC when no option is selected
            $('[data-atc] > span').text(window.theme.strings.makeSelection).parent().prop('disabled', true);
          });
        }
        ulHtml.append(liHtml);
        selectIndex++;
      });
      buttonsHtml.append(ulHtml);
    }

    var optGroups = select.children('optgroup');
    if (optGroups.length == 0) {
      addOptGroup(select);

    } else {
      optGroups.each(function () {
        addOptGroup($(this));

      });
    }

    select.after(buttonsHtml);

    buttonsHtml.find('a').click(function (e) {
      e.preventDefault();
      select.find('option').removeAttr('selected');
      var clickedOption = $(select.find('option')[$(this).attr('data-select-index')]);

      if (multiselect) {
        if (clickedOption.attr('selected')) {
          $(this).removeClass('picked');
          clickedOption.removeAttr('selected');
        } else {
          $(this).addClass('picked');
          clickedOption.attr('selected', 'selected');
        }
      } else {
        var change_pick = $(this).html();
        console.log(change_pick);
        console.log($(this).data('select-index'))
        $('.picked_value').html(change_pick);
        buttonsHtml.find('a, span').removeClass('picked');
        $(this).addClass('picked');
        
//         let selected_value = clickedOption.val();
        select.val(clickedOption.val());
//         clickedOption.attr('selected', 'selected');

        // Enable ATC
        $('[data-atc] > span').text(window.theme.strings.addToCart).parent().prop('disabled', false);
        $('#ProductSelect-product :nth-child('+($(this).data('select-index')+1)+')').prop('selected', true);
      }
      select.trigger('change');
    });
  });
};

$(document).ready(function () {
  $(".disabled").click(function () {
    var newdisabled = $(this).html();
    //var final_data =	$('span[id^="notifyme"]').remove();
    var test = $.trim($(this).text());

    var str = test;
    var n = str.includes(".5");
    if (n) {
      var res = test.slice(0, 13);
    } else {
      var res = test.slice(0, 11);
    }

    $('.picked_values').html("SIZE " + res + " - ");


    $('.picked_values_input').val("SIZE " + res + " - ");

    $(".popup-overlay, .popup-content").addClass("active");



  });

  $("#close_button").click(function () {
    //alert('close');
    $(".popup-overlay, .popup-content").removeClass('active');
  });

});




$(document).ready(function () {
  $(".select_hed").click(function () {
    $('#AddToCart-product').removeAttr('disabled').find('#AddToCartText-product').text('Add to cart')
    $(".select_box").fadeToggle("intro");

  });

  $(".select-buttons li").click(function () {
    $(".select_box").fadeToggle("intro");
	console.log('clicked')
  });
  
    $(document).on('click',".select-buttons li.disabled",function () {
         document.querySelector('.klaviyo-bis-trigger').click()                      
  });

});


